<script lang="ts">
    import { page } from '$app/stores';
    import { overlayPageLoadingFunctions } from './getSvelteImportsByTemplate';

    $: template = $page.state.overlay?.template;
    $: data = $page.state.overlay?.data;
    $: Layout = template ? overlayPageLoadingFunctions[template]?.layout : null;
    $: Page = template ? overlayPageLoadingFunctions[template]?.page : null;
</script>

{#if template && data && Page}
    {#if Layout}
        <svelte:component this={Layout} {data}>
            <svelte:component this={Page} {data} />
        </svelte:component>
    {:else}
        <svelte:component this={Page} {data} />
    {/if}
{/if}
